import { useLCS } from '@works-web/settings/modules/nds';
import { MenuItemId, PageContent } from '@works-web/settings/modules/page';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NotificationTab } from '../notiTime';
import { PopUp } from '../popup';
import { ServicesMenu } from '../services';
import { SnoozeNotification } from '../snoozeNotification';

MainScene.propTypes = {
  availableServices: PropTypes.array,
};

export default function MainScene({ availableServices }) {
  useLCS('pcset_notify');
  const { t } = useTranslation();
  const [snoozeOff, setSnoozeOff] = useState(true);
  const onSnoozeChange = (isSnoozeOff) => {
    if (isSnoozeOff !== snoozeOff) {
      setSnoozeOff(isSnoozeOff);
    }
  };

  return (
    <PageContent menuItemId={MenuItemId.NOTIFY}>
      <div className="settings_cover">
        <div className="title">
          <h3 className="title">
            <span className="text">{t('noti_main_quickset_title')}</span>
          </h3>
          <ul className="settings_list">
            <SnoozeNotification onSnoozeChange={onSnoozeChange} />
            <NotificationTab />
          </ul>
        </div>
      </div>
      {snoozeOff && (
        <div className="settings_cover">
          <h3 className="title">
            <span className="text">{t('noti_main_popupset')}</span>
          </h3>
          <ul className="settings_list">
            <PopUp availableServices={availableServices} />
          </ul>
        </div>
      )}
      <div className="settings_cover">
        <ServicesMenu services={availableServices} />
      </div>
    </PageContent>
  );
}
